import { Suspense } from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { ErrorBoundary } from '@/components/common/ErrorBoundary';
import { PageLoader } from '@/components/common/PageLoader';
import { DcrDashboardPage } from '@/features/dashboards/pages/DcrDashboardPage';
import { dcrDashboardSearchSchema } from '@/features/dashboards/types/dashboard.types';

export const Route = createFileRoute('/_auth/dashboards/dcr/')({
  validateSearch: dcrDashboardSearchSchema,
  component: () => (
    <ErrorBoundary moduleName="DCR Dashboard">
      <Suspense fallback={<PageLoader />}>
        <DcrDashboardPage />
      </Suspense>
    </ErrorBoundary>
  ),
});
